// extracted by mini-css-extract-plugin
module.exports = {"header":"work_header__37esh","title":"work_title__1M8Wt","dates":"work_dates__14igz"};